import React from "react";
import { Link } from "react-router-dom";

const MenuItem = ({ link, text, icon }) => {
  return (
    <li
      className={`flex items-center space-x-2 text-sm text-white capitalize hover:text-primary ${
        window.location.pathname === link && "text-primary"
      }`}
    >
      {icon}
      <Link to={link}>{text}</Link>
    </li>
  );
};

export default MenuItem;
